<template>
    <li
        class="calendar-day"
        :class="{
      'calendar-day--not-current': !day.isCurrentMonth,
      'calendar-day--today': isToday,
      'selected_slot': selectedDay,
      'slot-available': availableDays.includes(label)
    }"
        @click="$emit('daySelected', availableDays.includes(label)? day.date: '')"
    >
        <span>{{ label }}</span>
    </li>
</template>

<script>
import dayjs from "dayjs";

export default {
    name: "CalendarMonthDayItem",

    props: {
        day: {
            type: Object,
            required: true
        },
        isCurrentMonth: {
            type: Boolean,
            default: false
        },
        isToday: {
            type: Boolean,
            default: false
        },
        selectedDay: {
            type: Boolean,
            default: false
        },
        availableDays: {
            type: Array,
            default: []
        },
    },
    emits: ['daySelected'],

    computed: {
        label() {
            return dayjs(this.day.date).format("D");
        }
    }
};
</script>
